const pcnnews = [
  {
    size: "",
    style: "",
    class: "",
    children: [
      {
        type: "topbar",
        size: "12",
        style: "",
        class: "px-4",
        title: "PCN News",
      },
      {
        type: "tabs",
        size: "12",
        style: "",
        class: "px-4 pt-4",
        children: [
          {
            title: "News",
            service: "pages",
            size: "",
            style: "",
            class: "flex",
            topbarControls: {
              addNewButton: true,
              activeToggle: true,
              deleteButton: true,
              addNewSuccessTitle: "Topic Added!",
              addNewSuccessMessage: "Topic Added Successfully!",
              addNewErrorTitle: "Topic Creation Failed!",
              addNewErrorMessage: "Please try again!",
              deleteSuccessTitle: "Topic Deleted!",
              deleteSuccessMessage: "Topic Deleted Successfully!",
              deleteErrorTitle: "Topic Deletion Failed!",
              deleteErrorMessage: "Please try again!",
              activeSuccessTitle: "Topic Activated!",
              activeSuccessMessage: "Topic Activated Successfully!",
              activeErrorTitle: "Topic Activation Failed!",
              activeErrorMessage: "Please try again!",
              updateSuccessTitle: "Topic Updated!",
              updateSuccessMessage: "Topic Updated Successfully!",
              updateErrorTitle: "Topic Updation Failed!",
              updateErrorMessage: "Please try again!",
              addNewModal: {
                title: "Add New News",
                submit_url: "/api/categories/$currentCategoryId/pages",
                variant: "add",
                form: {
                  title: {
                    type: "text",
                    label: "News Title",
                    placeholder: "Enter News Title",
                    required: true,
                    info: true,
                    character_count: 100,
                    disabled: false,
                    class: "",
                    size: "12",
                    style: "",
                  },
                },
                additionalProps: {
                  date: "",
                  featured: false,
                  media_type: "Image",
                  url: "",
                  image_url: "",
                  video_url: "",
                  media: false,
                  image_preview: "",
                  schedule: false,
                  schedule_input: [],
                },
              },
            },
            children: [
              {
                type: "newsTab",
                size: "12",
                style: "",
                class: "p-0 d-flex",
                list: {
                  label: "Select News",
                  type: "list",
                  info: true,
                  size: "4",
                  style:
                    "border-right: 1px solid #DADCE3; min-height: calc(100vh - 144px)",
                  class: "p-0 pt-3 pr-3",
                  load_url: "/api/categories/$currentCategoryId/pages",
                  draggable: true,
                  children: [],
                  isGlobal: false,
                  featuredIcon_position: "left",
                  global: {
                    label: "Global Update",
                    type: "list",
                    info: true,
                    size: "4",
                    style:
                      "border-right: 1px solid #DADCE3; min-height: calc(100vh - 144px)",
                    class: "p-0 pt-3 pr-3",
                    load_url: "/api/categories/$currentCategoryId/pages",
                    draggable: true,
                    children: [],
                  },
                },
                form: {
                  type: "form",
                  variant: "patch",
                  size: "8",
                  style:
                    "margin-top: -4rem; border-left: 1px solid #DADCE3; min-height: calc(100vh - 144px)",
                  class: "pl-4 pt-3",
                  submit_url: "/api/pages/$currentPageId",
                  form: {
                    title: {
                      type: "text",
                      label: "News Title",
                      placeholder: "Enter News Title",
                      required: true,
                      info: true,
                      character_count: 100,
                      disabled: false,
                      class: "",
                      size: "12",
                      style: "",
                    },
                    description: {
                      type: "ckeditor",
                      label: "Description",
                      placeholder: "Enter Description",
                      required: false,
                      info: true,
                      character_count: 2000,
                      disabled: false,
                      class: "",
                      size: "12",
                      style: "",
                    },
                    date: {
                      type: "date",
                      label: "Date",
                      placeholder: "Enter Date",
                      required: true,
                      info: true,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "6",
                      style: "",
                    },
                    featured: {
                      type: "toggle",
                      label: "Featured",
                      placeholder: "Select Featured",
                      required: false,
                      info: true,
                      character_count: 0,
                      disabled: false,
                      featuredIcon: true,
                      class: "",
                      size: "6",
                      style: "",
                    },
                    hr1: {
                      type: "hr",
                      size: "12",
                    },
                    url: {
                      type: "slug",
                      label: "Path",
                      url: "/pcnnews/$slug",
                      placeholder: "Enter Path / Slug",
                      required: false,
                      info: true,
                      character_count: 0,
                      disabled: true,
                      class: "",
                      size: "12",
                      style: "",
                    },
                    hr5: {
                      type: "hr",
                      size: "12",
                    },
                    media: {
                      type: "toggle",
                      label: "Media",
                      placeholder: "",
                      required: false,
                      info: true,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "12",
                      style: "",
                    },
                    media_type: {
                      type: "select",
                      label: "Type",
                      placeholder: "Select Upload Option",
                      displayOn: "media",
                      displayOnValue: "true",
                      required: false,
                      info: true,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "6",
                      style: "",
                      options: ["None", "Image", "Video"],
                    },
                    image_url: {
                      type: "imgSelect",
                      label: "Image",
                      placeholder: "Select Image",
                      displayOn: "media_type",
                      displayOnValue: "Image",
                      displayOn2: "media",
                      displayOnValue2: "true",
                      load_url: "",
                      required: false,
                      info: false,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "6",
                      style: "",
                    },
                    video_url: {
                      type: "vidText",
                      label: "Video URL",
                      placeholder: "Enter Video URL",
                      displayOn: "media_type",
                      displayOnValue: "Video",
                      displayOn2: "media",
                      displayOnValue2: "true",
                      required: false,
                      info: true,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "6",
                      style: "",
                    },
                    image_preview: {
                      type: "imgPreview",
                      label: "",
                      placeholder: "",
                      displayOn: "media_type",
                      displayOnValue: "Image",
                      displayURL: "image_url",
                      displayOn2: "media",
                      displayOnValue2: "true",
                      load_url: "",
                      required: false,
                      info: false,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "6",
                      style: "",
                    },
                    hr3: {
                      type: "hr",
                      size: "12",
                    },
                    schedule: {
                      type: "toggle",
                      label: "Schedule",
                      placeholder: "",
                      required: false,
                      info: true,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "12",
                      style: "",
                    },
                    schedule_input: {
                      type: "schedulerinput",
                      label: " ",
                      placeholder: "",
                      required: false,
                      info: false,
                      character_count: 0,
                      displayOn: "schedule",
                      displayOnValue: "true",
                      disabled: false,
                      class: "",
                      size: "12",
                      style: "",
                    },
                    hr4: {
                      type: "hr",
                      size: "12",
                    },
                  },
                  children: [],
                },
              },
            ],
          },
          {
            title: "Settings",
            service: "category",
            size: "",
            style: "",
            class: "flex",
            topbarControls: {
              addNewButton: false,
              activeToggle: false,
              deleteButton: false,
              updateSuccessTitle: "Category Updated!",
              updateSuccessMessage: "Category Updated Successfully!",
              updateErrorTitle: "Category Updation Failed!",
              updateErrorMessage: "Please try again!",
            },
            children: [
              {
                type: "descriptionTab",
                size: "12",
                style: "",
                class: "p-0 d-flex",
                list: {
                  type: "list",
                  size: "4",
                  style: "",
                  class: "p-2",
                  empty: true,
                  children: [],
                },
                form: {
                  type: "form",
                  variant: "patch",
                  size: "8",
                  style:
                    "margin-top: -4rem; border-left: 1px solid #DADCE3; min-height: calc(100vh - 144px)",
                  class: "pl-4 pt-3",
                  form: {
                    // "twitter": {
                    //     "type": 'toggle',
                    //     "label": 'Twitter',
                    //     "placeholder": '',
                    //     "required": false,
                    //     "info": true,
                    //     "character_count": 0,
                    //     "disabled": false,
                    //     "class": '',
                    //     "size": "3",
                    //     "style": ""
                    // },
                    // "facebook": {
                    //     "type": 'toggle',
                    //     "label": 'Facebook',
                    //     "placeholder": '',
                    //     "required": false,
                    //     "info": true,
                    //     "character_count": 0,
                    //     "disabled": false,
                    //     "class": '',
                    //     "size": "3",
                    //     "style": ""
                    // },
                    // "hr1": {
                    //     "type": 'hr',
                    //     "size": "12",
                    // },
                    practice_newsletters: {
                      type: "toggle",
                      label: "PCN Newsletters",
                      placeholder: "",
                      required: false,
                      info: false,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "12",
                      style: "",
                    },
                    practice_newsletters_list: {
                      type: "variableList",
                      label: "PCN Newsletters List",
                      displayOn: "practice_newsletters",
                      displayOnValue: "true",
                      placeholder: "Select",
                      required: false,
                      info: false,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "12",
                      style: "",
                    },
                    hr2: {
                      type: "hr",
                      size: "12",
                    },
                    know_where_to_go: {
                      type: "toggle",
                      label: "Know Where To Go",
                      placeholder: "",
                      required: false,
                      info: true,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "12",
                      style: "",
                    },
                    hr3: {
                      type: "hr",
                      size: "12",
                    },
                    practice_location_check: {
                      type: "checkbox",
                      label: "Related Information",
                      placeholder: "PCN Location",
                      required: false,
                      info: false,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "12",
                      style: "",
                    },
                    practice_team_check: {
                      type: "checkbox",
                      label: "1",
                      hideLabel: true,
                      placeholder: "PCN Team",
                      required: false,
                      info: false,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "12",
                      style: "",
                    },
                    gp_and_nurse_availability_check: {
                      type: "checkbox",
                      label: "2",
                      hideLabel: true,
                      placeholder: "GP & Nurse Availablity",
                      required: false,
                      info: false,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "12",
                      style: "",
                    },
                    when_we_are_closed_check: {
                      type: "checkbox",
                      label: "3",
                      hideLabel: true,
                      placeholder: "When we are closed",
                      required: false,
                      info: false,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "12",
                      style: "",
                    },
                    contact_us_check: {
                      type: "checkbox",
                      label: "4",
                      hideLabel: true,
                      placeholder: "Contact Us",
                      required: false,
                      info: false,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "12",
                      style: "",
                    },
                    hr4: {
                      type: "hr",
                      size: "12",
                    },
                  },
                  children: [],
                },
              },
            ],
          },
        ],
      },
    ],
  },
];

export { pcnnews };
